module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICA8cGF0aCBpZD0ibWludXMtY2lyY2xlLXNvbGlkIiBkPSJNMTUsOGE3LDcsMCwxLDAsNyw3QTcsNywwLDAsMCwxNSw4Wm0tMy43MjYsOC4xMjlhLjM0LjM0LDAsMCwxLS4zMzktLjMzOVYxNC4yMWEuMzQuMzQsMCwwLDEsLjMzOS0uMzM5aDcuNDUyYS4zNC4zNCwwLDAsMSwuMzM5LjMzOVYxNS43OWEuMzQuMzQsMCwwLDEtLjMzOS4zMzlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOCAtOCkiIGZpbGw9IiNmMDNjM2MiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/remove-file-icon.svg
// module id = NBIZ
// module chunks = 3